import React from 'react'

import clsx from 'clsx'

import format   from 'vegas-js-core/src/strings/fastformat'
import isString from 'vegas-js-core/src/isString'
import notEmpty from 'vegas-js-core/src/strings/notEmpty'
import ucFirst  from 'vegas-js-core/src/strings/ucFirst'

import moment from 'moment'

import { FaBookDead } from 'react-icons/fa'

import ThingComponent from '../things/ThingComponent'

import withi18n  from '../../contexts/i18n/withi18n'
import withSnack from '../../contexts/snack/withSnack'

export class DeathLabel extends ThingComponent
{
    getLocale = () => this.props.locale.display.labels.death ;
    
    render = () =>
    {
        const thing = this.getThing();
        if ( thing ) 
        {
            const { deathDate , deathPlace } = thing;
            if ( deathDate || deathPlace )
            {
                const {
                    date,
                    pattern,
                    place,
                    separator
                } = this.getLocale() || {} ;

                let label = [] ;

                if( isString(deathDate) && (deathDate !== '') )
                {
                    label.push( format(date, moment(deathDate).format(pattern)) )  ;
                }

                if( isString(deathPlace) && (deathPlace !== '') )
                {
                    label.push( format(place,deathPlace) ) ;
                }

                if( label.length > 0 )
                {
                    label = ucFirst( label.join( (separator) )) ;
                }
                else
                {
                    label = null ;
                }

                if ( notEmpty(label) ) 
                {
                    const { className } = this.props;
                    return (
                        <div className={clsx("flex flex-row items-center p-8", className)} >
                            <div className="flex-initial">{ this.getIcon({ label }) } </div>
                            <div className="flex flex-col pl-8">
                                {this.getTitle()}
                                {this.getLabel(label)}
                            </div>
                        </div>
                    );
                }
            }
        }
        return null;
    }
}
    
DeathLabel.defaultProps =
{
    ...ThingComponent.defaultProps,
    icon : <FaBookDead style={{ fontSize:18 }} />
}

DeathLabel.propTypes =
{
    ...ThingComponent.propTypes
}

export default withSnack( withi18n( DeathLabel ) );